<div class="main">
    
    <div #appHeader>
      <xchange-site-header (exitEvent)="closeSidebar($event)"></xchange-site-header>
    </div>
    <ng-sidebar-container
      [allowSidebarBackdropControl]="true"
      (onBackdropClicked)="hideSidebar()"
      [backdropClass]="sidenavConfig.backdropClass"
      class="main-side-bar-container"
      [style.height.px]="calculateMinHeight(appHeader)"
    >
      <!-- A sidebar -->
      <ng-sidebar
        #sidebar
        [(opened)]="_opened"
        [showBackdrop]="sidenavConfig.showBackdrop"
        [mode]="sidenavConfig.mode"
        *ngIf="!hideSideBar"
        [closeOnClickBackdrop]="sidenavConfig.closeOnClickBackdrop"
        [sidebarClass]="sidenavConfig.sidebarClass"
        [dockedSize]="sidenavConfig.dockedSize"
        [dock]="sidenavConfig.dock"
      >
        <aside class="layout-side-bar">
          <xchange-site-sidenav class="overflow-x-axis"></xchange-site-sidenav>
        </aside>
      </ng-sidebar>
      <!-- Page content -->
      <div
        ng-sidebar-content
        class="page custom-scrollbar"
        #mainPage
        id="mainPage"
      >
        <div class="w-100 mt-3">
            <!-- <ng-container *ngIf="showCustomerMessages">
                <div class="row customer-messages-header">
                  <div class="col-6 systme-msg">
                    <p class="mt-2 mb-1">System Messages (5)</p>
                  </div>
                  <div class="col-6 hide-all">
                    <p class="mt-2 mb-1" (click)="hideCustomerMsg()">Hide All</p>
                  </div>
                </div>
      
                <div class="customer-messages-carousel mb-1">
                  <owl-carousel-o
                    [options]="sliderOptionsForCustomerMsg"
                    #owlCarousel
                  >
                    <ng-template
                      carouselSlide
                      *ngFor="let alert of salePersonNotifications"
                    >
                      <alert
                        type=""
                        class="dashboard-page-alert"
                        [dismissible]="true"
                        (onClosed)="onDismissAlert(alert)"
                      >
                        <div class="alert-content">
                          <div class="alert-img">
                            <img [src]="alert.src" alt="Customer Message" />
                          </div>
                          <div class="alert-msg">{{ alert.msg }}</div>
                        </div>
                      </alert>
                    </ng-template>
                  </owl-carousel-o>
                </div>
            </ng-container> -->
          <ng-container>
            <div class="customer-support">
              <span class="floating-icon">
                <a (click)="customerSupport(template3)">
                  <xchange-custom-icon
                    icon="icon-customer-support-new"
                  ></xchange-custom-icon>                
                </a>
              </span>
            </div>
          </ng-container>
          <router-outlet></router-outlet>
        </div>
        <xchange-site-footer></xchange-site-footer>
        <ng-template #template3>
          <div class="modal-header text-center">
            <h4 class="modal-title f-w w-100">Customer Support</h4>
            <button
              type="button"
              class="btn-close close pull-right"
              aria-label="Close"
              (click)="modalRef.hide()"
            >
              <span aria-hidden="true" class="visually-hidden">&times;</span>
            </button>
          </div>
          <div class="modal-body m-20">
            <div class="col-12">
              <div class="row">
                <div class="col-8 offset-2 text-center">
                  <p>For customer support inquiries related to services, orders, or any other concerns, please contact our support hotline between <br/><b>8 AM and 5:30 PM EST.</b></p>
                </div>
                <div class="col-12 col-xs-12 text-center">                
                  <table class="d-grid justify-content-center">
                    <tr>
                      <td class="text-end">Call:</td>
                      <td class="text-start"><a href="tel:1-800-276-7007">1-800-276-7007</a></td>
                    </tr>
                    <tr>
                      <td class="text-end invisible">Call:</td>
                      <td class="text-start"><a href="tel:1-706-629-7721,25125">1-706-629-7721 ext. 25125</a></td>
                    </tr>
                  </table>
                  <p>Email: <a href="mailto:xchange_support@mohawkind.com">xchange_support&#64;mohawkind.com</a></p>
                </div>
                <div class="container sales-team-container" *ngIf="salesTeamData.length > 0">
                  <div class="row">
                    <div class="col-10 col-xs-12 offset-1">
                      <p class="text-center heading">If you know your Mohawk Sales Rep, contact them below:</p>
                      <ul class="sales-team-list text-center">
                        <li *ngFor="let item of salesTeamData">
                          <div class="team-member-container">
                            <div class="team-content">
                                <b>{{ item?.name }}</b>
                                <p class="m-0">
                                  Email: <span class="color-red"><a href="{{item?.email}}">{{ item?.email }}</a></span>
                                </p>
                                <p>
                                  Mobile:
                                  <span class="color-red" *ngIf="item?.mobilePhone">
                                    <a href="tel:{{item?.mobilePhone}}">{{ item?.mobilePhone}}</a>
                                  </span>
                                  <span class="color-red not-available" *ngIf="!item?.mobilePhone">Not Available</span>
                                </p>                              
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-center">
            <button class="btn btn-primary me-3" (click)="modalService.hide()">
              CLOSE
            </button>
          </div>
        </ng-template>
      </div>
    </ng-sidebar-container>
  </div>
  